import { render, staticRenderFns } from "./Info-table.vue?vue&type=template&id=4b1d6ca5&scoped=true&"
import script from "./Info-table.vue?vue&type=script&lang=js&"
export * from "./Info-table.vue?vue&type=script&lang=js&"
import style0 from "./Info-table.vue?vue&type=style&index=0&id=4b1d6ca5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1d6ca5",
  null
  
)

export default component.exports